module.exports = __webpack_public_path__ + "img/about/80243-046.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-046.png
// module id = 44
// module chunks = 0